export default {
  hljs: {
    display: 'block',
    padding: '0em',
    background: 'white',
    color: 'black',
  },
  'hljs-string': {
    color: '#666',
  },
  'hljs-variable': {
    color: '#666',
  },
  'hljs-template-variable': {
    color: '#666',
  },
  'hljs-symbol': {
    color: '#666',
  },
  'hljs-bullet': {
    color: '#666',
  },
  'hljs-section': {
    color: '#666',
    fontWeight: 'bold',
  },
  'hljs-addition': {
    color: '#666',
  },
  'hljs-attribute': {
    color: '#666',
  },
  'hljs-link': {
    color: '#666',
  },
  'hljs-comment': {
    color: '#aaa',
  },
  'hljs-quote': {
    color: '#aaa',
  },
  'hljs-meta': {
    color: '#aaa',
  },
  'hljs-deletion': {
    color: '#aaa',
  },
  'hljs-keyword': {
    fontWeight: 'bold',
  },
  'hljs-selector-tag': {
    fontWeight: 'bold',
  },
  'hljs-name': {
    fontWeight: 'bold',
  },
  'hljs-type': {
    fontWeight: 'bold',
  },
  'hljs-strong': {
    fontWeight: 'bold',
  },
  'hljs-emphasis': {
    fontStyle: 'italic',
  },
};
